import { axios } from "./http.js";

export const login = params => axios.post("/home/account", params);

// 获取首页图片
export const getHomeScroll = () => axios.get(`/home/scroll`);
